import {
  ClientCategoryType,
  ClientClassificationType,
  ClientEconomicSectorType,
  ClientTypeClient,
} from 'api/types/entity';
import { yesOrNotSelectValidation } from 'helpers';
import {
  ObjectSchema,
  string,
  object,
  mixed,
  TypedForm,
  selectSchema,
} from 'libs/form';
import {
  BaseGeneralFormType,
  baseGeneralSchema,
} from 'modules/client/common/forms/baseGeneralForm';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface GeneralFormType {
  general: BaseGeneralFormType & {
    clientType?: Maybe<SelectType<ClientTypeClient>>;
    category?: Maybe<SelectType<ClientCategoryType>>;
    classification?: Maybe<SelectType<ClientClassificationType>>;
    economicSector?: Maybe<SelectType<ClientEconomicSectorType>>;
    isInsider?: Maybe<YesOrNoSelectType>;
  };
}

export const generalSchema: ObjectSchema<GeneralFormType> = object({
  general: object({
    clientType: selectSchema(Object.values(ClientTypeClient))
      .nullable()
      .default(null),

    category: selectSchema(Object.values(ClientCategoryType))
      .nullable()
      .default(null),

    classification: selectSchema(Object.values(ClientClassificationType))
      .nullable()
      .default(null),

    economicSector: object({
      value: mixed<ClientEconomicSectorType>()
        .oneOf(Object.values(ClientEconomicSectorType))
        .required(),
      label: string().required(),
    })
      .nullable()
      .default(null),
    isInsider: yesOrNotSelectValidation.nullable().default(null),
  }).concat(baseGeneralSchema),
});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<GeneralFormType>();
